// Source: https://gist.github.com/orlandovallejos/ed9c79dd67e96c25cfcc8f1008df9489
/*------------------------------------------------*/
/* LIBRARIES
/*------------------------------------------------*/
import { throttle } from 'lodash';

/*------------------------------------------------*/
/* INTERNAL DEPENDENCIES
/*------------------------------------------------*/
import { ROOT_BLOCK_ID } from '~/common/flows.constants';

/*------------------------------------------------*/
/* CONSTANTS
/*------------------------------------------------*/
const OFFSET = 200;
const PX_DIFF = 7;

/*------------------------------------------------*/
/* GLOBAL VARIABLES
/*------------------------------------------------*/
let scrollIncrement = 0;
let isScrolling = false;
let rootBlockElement: HTMLElement = null;

/*------------------------------------------------*/
/* METHODS
/*------------------------------------------------*/

/**
 * Scroll up in the sidebar.
 */
const goUp = () => {
    scrollIncrement -= PX_DIFF;
    rootBlockElement.scrollTop = scrollIncrement;

    if (isScrolling && scrollIncrement >= 0) {
        window.requestAnimationFrame(goUp);
    }
};

/**
 * Scroll down in the sidebar.
 */
const goDown = () => {
    scrollIncrement += PX_DIFF;
    rootBlockElement.scrollTop = scrollIncrement;

    if (isScrolling && scrollIncrement <= rootBlockElement.scrollHeight) {
        window.requestAnimationFrame(goDown);
    }
};

const onDragOver = event => {
    const clientRect = rootBlockElement.getBoundingClientRect();

    const isMouseOnTop =
        scrollIncrement >= 0 &&
        event.clientY > clientRect.top &&
        event.clientY < clientRect.top + OFFSET;

    const isMouseOnBottom =
        scrollIncrement <= rootBlockElement.scrollHeight &&
        event.clientY > window.innerHeight - OFFSET &&
        event.clientY <= window.innerHeight;

    if (!isScrolling && (isMouseOnTop || isMouseOnBottom)) {
        isScrolling = true;
        scrollIncrement = rootBlockElement.scrollTop;

        if (isMouseOnTop) {
            window.requestAnimationFrame(goUp);
        } else {
            window.requestAnimationFrame(goDown);
        }
    } else if (!isMouseOnTop && !isMouseOnBottom) {
        isScrolling = false;
    }
};

/**
 * The "throttle" method prevents executing the same function SO MANY times.
 */
const throttleOnDragOver = throttle(onDragOver, 300, {
    leading: true,
    trailing: false
});

// IMPORTANT: CALL THIS METHOD IN: beginDrag!!!
export const addEventListenerForRootBlock = () => {
    rootBlockElement = document.getElementById(ROOT_BLOCK_ID);
    rootBlockElement.addEventListener('dragover', throttleOnDragOver);
};

// IMPORTANT: CALL THIS METHOD IN: endDrag!!!
export const removeEventListenerForRootBlock = () => {
    rootBlockElement.removeEventListener('dragover', throttleOnDragOver);
    throttleOnDragOver.cancel();
    isScrolling = false;
};

export const scrollToElement = (scrollOptions: ScrollToOptions) => {
    rootBlockElement = document.getElementById(ROOT_BLOCK_ID);
    rootBlockElement?.scrollBy(scrollOptions);
};
